import { SupportMaterial, SupportMaterialTypes } from 'store/product/types';

const findSupportMaterial = (materials: SupportMaterial[], targetMaterialType: SupportMaterialTypes) => {
  const result = materials.filter((m) => m.type === targetMaterialType);
  if (!result.length) return undefined;
  return result[0].value;
};

export default findSupportMaterial;
